import { useState } from 'react';
import styles from './ResinaModal.module.css';

export default function ResinaModal({ resina, onSalvar, onCancelar }) {
  const editando = !!resina;

  const [nome, setNome] = useState(resina?.nome || '');
  const [descricao, setDescricao] = useState(resina?.descricao || '');
  const [ativo, setAtivo] = useState(resina?.ativo ?? true);

  const valido = nome.trim().length > 0;

  function handleSalvar() {
    if (!valido) {
      alert('Preencha o nome da resina.');
      return;
    }
    onSalvar({
      nome: nome.trim(),
      descricao: descricao.trim(),
      ativo,
    });
  }

  return (
    <div className={`${styles.modalOverlay} ${styles.aberto}`}>
      <div className={styles.modal}>
        <div className={styles.modalHead}>
          <div>
            <div className={styles.modalTitle}>
              {editando ? 'Editar resina' : 'Nova resina'}
            </div>
            <div className={styles.modalSubtitle}>
              Preencha os dados da resina. Campos com * são obrigatórios.
            </div>
          </div>
          <button className={styles.modalClose} onClick={onCancelar}>
            ✕
          </button>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.formSection}>
            <div className={styles.formSectionTitle}>Identificação</div>
            <div className={styles.formField}>
              <label className={styles.formLabel}>
                Nome <span className={styles.obrigatorio}>*</span>
              </label>
              <input
                className={styles.formInput}
                placeholder="Ex: EPÓXI"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
              />
            </div>
            <div className={styles.formField} style={{ marginTop: 12 }}>
              <label className={styles.formLabel}>Descrição</label>
              <textarea
                className={styles.formTextarea}
                placeholder="Ex: Resinas epóxi de alta resistência química e mecânica..."
                value={descricao}
                onChange={(e) => setDescricao(e.target.value)}
              />
              <div className={styles.formHint}>
                Texto livre descrevendo características da resina.
              </div>
            </div>
          </div>

          <div className={styles.formSection}>
            <div className={styles.formSectionTitle}>Status</div>
            <div className={styles.toggleStatus}>
              <div
                className={`${styles.toggleSwitch} ${ativo ? styles.ativo : ''}`}
                onClick={() => setAtivo(!ativo)}
              />
              <div className={styles.toggleLabel}>
                Resina {ativo ? 'ativa' : 'inativa'}
                <small>
                  Resinas inativas não aparecem ao cadastrar novos produtos.
                </small>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.modalFoot}>
          <button className={styles.btnSecondary} onClick={onCancelar}>
            Cancelar
          </button>
          <button
            className={styles.btnPrimary}
            onClick={handleSalvar}
            disabled={!valido}
          >
            {editando ? 'Salvar alterações' : 'Cadastrar resina'}
          </button>
        </div>
      </div>
    </div>
  );
}
